<template>
  <div class=''>
      <Header :widthmun='windowWidth'/>

      <div class="new_box">
          <div class="container sp">
              <el-row>
                  <el-col :span="24">
                      <div class="col_list">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{$t('home.home')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{$t('new.title')}}</el-breadcrumb-item>
                          </el-breadcrumb>
                      </div>
                      <h2 class="showtitle">{{$t('new.title')}}</h2>
                  </el-col>
              </el-row>
            
          </div>
      </div>

        <div class="content">
            <div class="container newcont">
                <el-row>
                    <el-col class="el-col-box">
                        <div class="cont_box">

                            <!-- 新闻内容 -->
                            <div class="new_box_list" v-if="formData">
                                <div v-if="lang == 'en-US'">
                                    <p class="title">{{formData.titleEn}}</p>
                                    <div class="date_box">
                                        <h6>{{$t('new.cn1.nyuan')}}<el-link :underline="false" :href="formData.sourceUrl" target="_blank" style="padding-left:10px;color:#409EFF" class="link">{{formData.sourceText}}</el-link></h6>
                                        <h6>{{formData.releaseDateEn}}</h6>
                                    </div>
                                    <div v-html="formData.textEn"></div>
                                </div>
                                <div v-if="lang == 'zh-CN'">
                                    <p class="title">{{formData.titleZh == 'nodisplay' ? formData.titleEn : formData.titleZh}}</p>
                                    <div class="date_box">
                                        <h6>{{$t('new.cn1.nyuan')}}<el-link :underline="false" :href="formData.sourceUrl" target="_blank" style="padding-left:10px;color:#409EFF" class="link">{{formData.sourceText}}</el-link></h6>
                                        <h6>{{formatDates(formData.releaseDateZh)}}</h6>
                                    </div>
                                    <div v-html="formData.textZh"></div>
                                </div>

                                
                            </div>


                            


                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

      <Footer :widthmun='windowWidth'/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer/index.vue';
import { getDefaultStartTime, formatDates } from "@/util/date";
import news from '@/api/new'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Header,Footer},
  data () {
  // 这里存放数据
    return {
        parmaid:'',
        lang:this.$i18n.locale,
        newsArr:[],
        formData:{},
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
      windowHeight (val) {
        let that = this;
        
      },
      windowWidth (val) {
        let that = this;
        this.windowWidth = val
      },
      '$i18n.locale'(val) {
        this.lang = val
      },
  },
  // 方法集合
  methods: {
        formatDates: function (dataVal) {
            if (null == dataVal) {
                return "";
            }
            return formatDates(dataVal);
        },
        getActiveNewsList(){
            let status = 2
            if(window.location.origin.indexOf('mock') != -1){
                status = null
            }
            news.getActiveNewsListByCategory(response => {
                if(response.content){
                    let newsList = response.content
                    this.newsArr=[];
                    for(let i = 0 ; i < newsList.length ; i++){
                        news.getNewsById(response => {
                            if(response){
                                this.newsArr.push(response)
                            }else{
                                this.$message.error('error');
                            }
                        },{ "id": newsList[i].id ,'status':status })
                    }
                }
            },{ "category": 1 })
        },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        let status = 2
        if(window.location.origin.indexOf('mock') != -1){
            status = null
        }
        if (this.$route.query.id) {
            news.getNewsById(response => {
                if(response){
                    this.formData = response
                }else{
                    this.$message.error('error');
                }
            },{ "id": this.$route.query.id ,'status':status })
        }else{
            this.getActiveNewsList()
        }
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth;
                this.windowHeight = window.fullHeight;  // 高
                this.windowWidth = window.fullWidth; // 宽
            })()
        }
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:10%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.showtitle {
    color: #fff!important;
    font-size:40px;
    line-height: 50px;
}


.content{
    margin-top:-35px;
    min-height:700px;
    
    .el-row{
        background: #fff;
    }
    .cont_box{
        padding:20px;
    }
    .title{
        font-size:28px;
        line-height: 38px;
        margin-top:20px;
        font-family:inherit;
    }
    .h5{
        font-size:20px;
        line-height: 30px;
        margin-top:20px;
        font-family:inherit;
    }
    h6{
        font-size:16px;
        margin-bottom:25px;
        font-weight: normal;
    }
    p{
        margin-top:0;
        margin-bottom:16px;
        font-size:16px;
        line-height: 30px;
    }
    .new_box_list{
        padding-top:10px;
        padding-bottom:20px;
    }
}
.date_box{
    display: flex;
    h6{
        margin-right:30px;
    }
}
.el-col-box{
    border:0.1px solid #fff;
    box-shadow: 0px 5px 15px rgba(136,136,136,0.2);
}
</style>
